import { Button } from '@chatui/core';
import './style.css';
import { useCallback, useState } from 'react';
import { MultiMediaReponseType } from '../../../utils/types';

interface QuickOptionCardProps {
  options: MultiMediaReponseType;
  actions: { onSelect: (option: string) => void };
}
const QuickOptionCard = ({ options, actions }: QuickOptionCardProps) => {
  const { data } = options;
  const [selected, setSelected] = useState<number | null>(null);
  const handleClick = useCallback(
    (option: string, index: number) => {
      setSelected(index);
      actions.onSelect(option);
    },
    [actions]
  );

  return (
    <div className="quick-option">
      {data.map((option: string, index: number) => (
        <Button
          key={index}
          onClick={() => {
            handleClick(option, index);
          }}
          color={
            selected === null || selected === index ? 'primary' : undefined
          }
          size="sm"
          variant="outline"
          disabled={selected !== null}
        >
          {option}
        </Button>
      ))}
    </div>
  );
};

export default QuickOptionCard;
